import { Service } from "../../../api/pricelist.types";
import { PricelistServiceAction } from "./pricelist.service.types";

export const pricelistServiceRequest = (params: { pls_id: number }): PricelistServiceAction => ({ type: 'PRICELIST_SERVICE_REQUEST', params })

export const pricelistServiceSuccess = (service: Service): PricelistServiceAction => ({ type: 'PRICELIST_SERVICE_SUCCESS', params: service })

export const pricelistServiceFailure = (error?: any) => ({ type: 'PRICELIST_SERVICE_FAILURE' } as const)